module.exports = __webpack_public_path__ + "static/media/google.fcd2e00b.svg";